module.exports = __webpack_public_path__ + "img/target-savings-low.23442162.svg";